var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-only",class:{ [_vm.$style['scroll-to-top']]: true, [_vm.$style['scroll-to-top--show']]: _vm.showScrollToTop },attrs:{"id":"scroll-to-top"},on:{"click":function($event){return _vm.scrollToTop()}}},[_c('span',[_c('IconSelect',{attrs:{"icon":"chevronUp"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }